import React, { useState } from "react";
import { ForecastChartComponent } from "../../components/ForecastChartComponent.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { AnalyzerDetailedTable } from "../../components/AnalyzerDetailedTable.jsx";

const ForecastView = (props) => {
    const { data, dateFormat, dateGrouping, setDateGrouping, title, subtitle, valueName, showButtons, grouping,   selectedResource, forecastType } = props;

    const [currentView, setCurrentView] = useState("chart-stacked");
    const [showPreviousMonth, setShowPreviousMonth] = useState(true);
    const [showNextMonth, setShowNextMonth] = useState(true);



	const buttons = showButtons ? (
		<div className="flex flex-row">
			{/* <div className="flex flex-row mr-4 w-[180px]">
				{circleButton("D", dateGrouping === "MMM D", () => {handleGroupingClick("day")})}
				{circleButton("W", dateGrouping === "YYYY-WW", () => {handleGroupingClick("week")})}
				{circleButton("M", dateGrouping === "MMM YYYY", () => {handleGroupingClick("month")})}
				{circleButton("Q", dateGrouping === "YYYY-Q", () => {handleGroupingClick("quarter")})}
				{circleButton("Y", dateGrouping === "YYYY", () => {handleGroupingClick("year")})}
			</div> */}
			<div className="flex flex-row mr-8 mt-1">
                {/* Stacked Chart view */}
				<div 
                    className={`border rounded-ctrl h-[28px] w-[40px] border-border hover:border-border-strong  cursor-pointer ${currentView === "chart-stacked" ? "bg-text text-text-inverse" : "bg-card text-text"}`}
                    onClick={() => setCurrentView("chart-stacked")}
                >
					<FontAwesomeIcon title="Overview" icon={icon({name: 'chart-area', family: 'classic', style: 'light'})} className="ml-3 mt-1 border-white "/>
				</div>

                {/* Overlapping Chart view */}
				{/* <div 
                    className={`border rounded-lg ml-1 h-[28px] w-[40px] border-border hover:border-border-strong  cursor-pointer ${currentView === "chart" ? "bg-primary text-white" : "bg-card text-text-2"}`}
                    onClick={() => setCurrentView("chart")}
                >
					<FontAwesomeIcon title="Overview" icon={icon({name: 'chart-line', family: 'classic', style: 'light'})} className="ml-3 mt-1 border-white "/>
				</div> */}

                {/* Table view */}
				<div 
                    className={`border rounded-ctrl ml-1 h-[28px] w-[40px] border-border hover:border-border-strong cursor-pointer ${currentView === "table" ? "bg-text text-text-inverse" : "bg-card text-text"}`}
                    onClick={() => setCurrentView("table")}
                >
					<FontAwesomeIcon title="Overview" icon={icon({name: 'table', family: 'classic', style: 'light'})} className="ml-3 mt-1 border-white "/>
				</div>
			</div>
		</div>
	) : null;

	return (
		<div>
            <div className="flex flex-row justify-between items-center cursor-default mb-2">
				{/* <div className="text-coolgrey3 text-lg font-semibold mt-4">{title}</div> */}
				{/* Checkboxes for showing/hiding months */}
				<div className="flex flex-row gap-4 items-center">
					<label className="flex items-center cursor-pointer">
						<input
							type="checkbox"
							checked={showPreviousMonth}
							onChange={(e) => setShowPreviousMonth(e.target.checked)}
							className="mr-2 w-4 h-4 text-text border-border rounded focus:ring-ring"
						/>
						<span className="text-sm text-text-2">Show previous month</span>
					</label>
					<label className="flex items-center cursor-pointer">
						<input
							type="checkbox"
							checked={showNextMonth}
							onChange={(e) => setShowNextMonth(e.target.checked)}
							className="mr-2 w-4 h-4 text-text border-border rounded focus:ring-ring"
						/>
						<span className="text-sm text-text-2">Show next month</span>
					</label>
				</div>
				{buttons}
			</div>
            
            {currentView === "chart" || currentView === "chart-stacked" ? (
                <>
                <ForecastChartComponent
                    data={data}
                    dateFormat={dateFormat}
                    dateGrouping={dateGrouping}
                    setDateGrouping={setDateGrouping}
                    title={title}
                    subtitle={subtitle}
                    valueName={valueName}
                    showButtons={true}
					stacked={currentView === "chart-stacked"}
                    includeForecast={true}
                    selectedSeries={selectedResource}
                    forecastType={forecastType}
                    showPreviousMonth={showPreviousMonth}
                    showNextMonth={showNextMonth}
                />
                {/* <TableComponent
                    data={groupedData}
                    grouping={grouping}
					title={"Totals per " + grouping.toLowerCase()}
                    fillColors={fillColors}
                /> */}
                </>
            ) : (
                <AnalyzerDetailedTable
                    sourceData={data} 
                    grouping={grouping}
                    dateGrouping={dateGrouping}
                    setDateGrouping={setDateGrouping}
					includeForecast={true}
                />
            )}
		</div>
	)
}

export default ForecastView;